import axios from "../../../axios";

export const getProjectData = async () => {
  return axios.get("/api/Project/ProjectData");
};

export const AdminGetAllProject = async () => {
  return axios.get("/api/Admin/GetAllProject");
};

export const createProject = async (payload) => {
  return axios.post("/api/Project/Create", payload);
};

export const getActiveTeam = async (ProjectUID) => {
  return axios.get(`/api/Project/ActiveTeam/${ProjectUID}`);
};

export const getAvailableTeam = async (ProjectUID) => {
  return axios.get(`/api/Project/AvaliableTeam/${ProjectUID}`);
};

export const addDeveloper = async (payload) => {
  return axios.post("/api/Project/AddDevelopers", payload);
};


